<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title>
        <p class="font-bold">Contrato</p>
      </mat-card-title>
    </div>
    <button
      mat-flat-button
      class="flex flex-row btn-tg w-12/12"
      (click)="close()"
    >
      Voltar
    </button>
  </mat-card-header>
  <div class="my-4">
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Informações</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div [formGroup]="formLegalEntity" class="mt-4 container mx-auto">
            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Status Contrato</mat-label>
                <input
                  matInput
                  [value]="
                    getStatusDescricao(
                      formLegalEntity.get('statusPropostaId')?.value
                    )
                  "
                  readonly
                />
              </mat-form-field>
              <!--    </div>-->

              <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Nome evento</mat-label>
                <input matInput formControlName="eventName" readonly />
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Código TG</mat-label>
                <input matInput formControlName="codigTg" readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data inicio</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateStart"
                  formControlName="dateStart"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateStart"
                  [disabled]="true"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart [disabled]="true"></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateEnd"
                  formControlName="dateEnd"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateEnd"
                  [disabled]="true"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd [disabled]="true"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="flex justify-start items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Quant. passageiros</mat-label>
                <input
                  matInput
                  formControlName="numPassengers"
                  integerInput
                  readonly
                />
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12" appearance="outline">
                <mat-label>Forma/prazo de pagamento</mat-label>
                <input matInput formControlName="paymentMethod" readonly />
              </mat-form-field>
            </div>
            <div class="flex justify-end items-center mt-3 -mx-2">
              <mat-form-field
                class="input-tg w-2/12 no-message-new"
                appearance="outline"
              >
                <mat-label>Total Geral</mat-label>
                @if (formLegalEntity.get('grandTotal')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="grandTotal" readonly />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <!--      <div class="mt-4"></div>-->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Cliente</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <div [formGroup]="formLegalEntity" [hidden]="typeClient != 'legal'">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-5/12" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="client" readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-5/12" appearance="outline">
                <mat-label>Razão social</mat-label>
                <input matInput formControlName="corporate_name" readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>CNPJ</mat-label>
                <input
                  matInput
                  formControlName="cnpj"
                  [mask]="'00.000.000/0000-00'"
                  readonly
                />
              </mat-form-field>
            </div>
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Inscrição Estadual</mat-label>
                <input matInput formControlName="reg_state" readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Inscrição Municipal</mat-label>
                <input matInput formControlName="reg_municipal" readonly />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <!--      <div class="mt-4"></div>-->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Solicitante</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="formLegalEntity" class="mt-4 container mx-auto">
          <div class="input-box flex justify-between items-center w-full">
            <mat-form-field
              class="input-tg w-4/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Nome</mat-label>
              <input matInput formControlName="requesterName" readonly />
            </mat-form-field>

            <mat-form-field
              class="input-tg w-4/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Email</mat-label>
              <input matInput formControlName="requesterEmail" readonly />
            </mat-form-field>

            <mat-form-field
              class="input-tg w-4/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Telefone</mat-label>
              <input
                matInput
                formControlName="requesterPhone"
                [mask]="'(00) 00000-0000'"
                readonly
              />
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <!--      <div class="mt-4"></div>-->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Consultor Cliente</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <div [formGroup]="formLegalEntity">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="consultantClient" readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="consultantEmail" readonly />
              </mat-form-field>
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input
                  matInput
                  formControlName="consultantPhone"
                  [mask]="'(00) 00000-0000'"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <!--      <div class="mt-4"></div>-->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Consultor Comercial</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <div [formGroup]="formLegalEntity">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="consultantComerce" readonly />
              </mat-form-field>
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Cpf</mat-label>
                <input
                  matInput
                  formControlName="consultantComercialCpf"
                  [mask]="'000.000.000-00'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="consultantComercialEmail"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <!--      <div class="mt-4"></div>-->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Consultor Operacional</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <div [formGroup]="formLegalEntity">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-4/12" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="consultantOperate" readonly />
              </mat-form-field>
              <mat-form-field class="input-tg w-4/12" appearance="outline">
                <mat-label>Cpf</mat-label>
                <input
                  matInput
                  formControlName="consultantOperateCpf"
                  [mask]="'000.000.000-00'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12" appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="consultantOperateEmail"
                  readonly
                />
              </mat-form-field>
              <button
                mat-flat-button
                class="btn-tg w-1/12"
                (click)="associateConstOp()"
                [disabled]="loadingAssociate"
              >
                @if (loadingAssociate) {
                } @else {
                  {{ consultantOpId ? 'Editar' : 'Associar' }}
                }
              </button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Itens Contrato</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mb-4 flex justify-end">
          <!--  <button mat-raised-button class="btn-add" (click)="addItemProposal()">-->
          <!--    Cadastrar-->
          <!--    <mat-icon>add</mat-icon>-->
          <!--  </button>-->
        </div>
        <div>
          <!--  <form-client-search-->
          <!--    [search]="inputSearchContact"-->
          <!--    [listSearch]="listSearch"-->
          <!--    (responseSearch)="search($event)"-->
          <!--  />-->
          @if (!loading) {
            <div class="tab-overflow">
              <table
                mat-table
                [dataSource]="tableSource"
                class="mat-elevation-z8"
              >
                @for (column of columns; track column.keyColumn) {
                  <ng-container matColumnDef="{{ column.keyColumn }}">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ column.description }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (column.keyColumn == 'action') {
                        <div class="flex justify-center items-center gap-3">
                          @if (element.statusId != 1) {
                            <mat-icon
                              class="btn-icon-outline"
                              fontIcon="visibility"
                              (click)="selectItemEvent(element)"
                            />
                          }
                          <!--                  @if (column.key.delete) {-->
                          <!--                    <mat-icon-->
                          <!--                      class="btn-icon-outline"-->
                          <!--                      fontIcon="delete"-->
                          <!--                      (click)="deleteItemEvent(element)"-->
                          <!--                    />-->
                          <!--                  }-->
                        </div>
                      } @else if (column.keyColumn == 'location_OD') {
                        <b>Origem: </b>{{ element.cidadeOrigem }}<br />
                        <b>Destino: </b>{{ element.cidadeDestino }}
                      } @else if (column.keyColumn == 'servico_TS') {
                        <b>Tipo: </b>{{ element.tipoServicoDescricao }}<br />
                        <b>Serviço: </b>{{ element.serfvicoDescricao }}
                      } @else if (column.keyColumn == 'vehicle_VM') {
                        <b>Tipo veículo: </b>{{ element.tipoVeiculoDescricao
                        }}<br />
                        <b>Tipo motorista: </b
                        >{{ element.tipoMotoristaDescricao }}
                      } @else {
                        {{ element[column.key] }}
                      }
                    </td>
                  </ng-container>
                }
                <tr
                  mat-header-row
                  class="style-header"
                  *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                  mat-row
                  class="style-row"
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          <mat-paginator
            [hidden]="loading"
            #paginator
            [pageSize]="5"
            (page)="pageChanged($event)"
          >
          </mat-paginator>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Upload de Arquivo</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <contract-upload
          [idCliente]="data.clientePessoaId"
          [idContrato]="data.id"
        ></contract-upload>
      </mat-expansion-panel>
      <!--      <div class="mt-4"></div>-->
      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Compras</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel> -->
      <!--Pagamento-->
      <!--Consultor-->
      <!--Itens-->
    </mat-accordion>
  </div>
</mat-card>
